var _style, _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 172 172",
    style: {
      enableBackground: "new 0 0 172 172"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#141414;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#333333;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1380.7,
    y: -84.7,
    className: "st0",
    width: 172,
    height: 345.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -87,
    className: "st1",
    width: 172,
    height: 350
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.8,36.2 50.6,21.5 29.1,0 28.3,0 49.8,21.5 35.8,35.4 7.6,7.2 14.7,0 13.9,0 6.8,7.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.9,0 0,13.9 0,14.7 14.7,0  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "93.2,36.2 107.9,21.5 86.4,0 85.6,0 107.1,21.5 93.2,35.4 64.9,7.2 72.1,0 71.3,0 64.1,7.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "50.2,21.9 72.1,0 71.3,0 50.2,21.1 36.2,7.2 43.4,0 42.6,0 35.4,7.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "150.5,36.2 165.2,21.5 143.7,0 142.9,0 164.4,21.5 150.5,35.4 122.2,7.2 129.4,0 128.6,0 121.4,7.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "107.5,21.9 129.4,0 128.6,0 107.5,21.1 93.6,7.2 100.7,0 99.9,0 92.8,7.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "164.8,21.9 172,14.7 172,13.9 164.8,21.1 150.9,7.2 158.1,0 157.3,0 150.1,7.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "43.4,0 42.6,0 35.8,6.8 29.1,0 28.3,0 35.8,7.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "100.7,0 99.9,0 93.2,6.8 86.4,0 85.6,0 93.2,7.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "158.1,0 157.3,0 150.5,6.8 143.7,0 142.9,0 150.5,7.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.8,64.9l-29-29.1l14.7-14.7l29.1,29.1L35.8,64.9z M7.6,35.8l28.3,28.3l13.9-13.9L21.5,21.9L7.6,35.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.2,6.8 0,13.9 0,14.7 7.2,7.6 21.1,21.5 0,42.6 0,43.4 21.9,21.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.2,64.9L64.1,35.8l14.7-14.7l29.1,29.1L93.2,64.9z M64.9,35.8l28.3,28.3l13.9-13.9L78.8,21.9L64.9,35.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.2,50.6L35.4,35.8l29.1-29l14.7,14.7L50.2,50.6z M36.2,35.8l13.9,13.9l28.3-28.3L64.5,7.6L36.2,35.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.5,64.9l-29.1-29.1l14.7-14.7l29.1,29.1L150.5,64.9z M122.2,35.8l28.3,28.3l13.9-13.9l-28.3-28.3 L122.2,35.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.5,50.6L92.8,35.8l29.1-29.1l14.7,14.7L107.5,50.6z M93.6,35.8l13.9,13.9l28.3-28.3l-14-13.8L93.6,35.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "164.8,50.6 172,43.4 172,42.6 164.8,49.8 150.9,35.8 172,14.7 172,13.9 150.1,35.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.8,93.6l-29-29.1l14.7-14.7l29.1,29.1L35.8,93.6z M7.6,64.5l28.3,28.3l13.9-13.9L21.5,50.6L7.6,64.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.2,35.4 0,42.6 0,43.4 7.2,36.2 21.1,50.2 0,71.3 0,72.1 21.9,50.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.2,93.6L64.1,64.5l14.7-14.7l29.1,29.1L93.2,93.6z M64.9,64.5l28.3,28.3l13.9-13.9L78.8,50.6L64.9,64.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.2,79.2L35.4,64.5l29.1-29.1l14.7,14.7L50.2,79.2z M36.2,64.5l13.9,13.9l28.3-28.3L64.5,36.2L36.2,64.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.5,93.6l-29.1-29.1l14.7-14.7l29.1,29.1L150.5,93.6z M122.2,64.5l28.3,28.3l13.9-13.9l-28.3-28.3 L122.2,64.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.5,79.2L92.8,64.5l29.1-29.1l14.7,14.7L107.5,79.2z M93.6,64.5l13.9,13.9l28.3-28.3l-13.9-13.9L93.6,64.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "164.8,79.2 172,72.1 172,71.3 164.8,78.4 150.9,64.5 172,43.4 172,42.6 150.1,64.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.8,122.2l-29-29l14.7-14.7l29.1,29.1L35.8,122.2z M7.6,93.2l28.3,28.3l13.9-13.9L21.5,79.2L7.6,93.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.2,64.1 0,71.3 0,72.1 7.2,64.9 21.1,78.8 0,99.9 0,100.7 21.9,78.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.2,122.2l-29.1-29l14.7-14.7l29.1,29.1L93.2,122.2z M64.9,93.2l28.3,28.3l13.9-13.9L78.8,79.2L64.9,93.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.2,107.9L35.4,93.2l29.1-29.1l14.7,14.7L50.2,107.9z M36.2,93.2l13.9,13.9l28.3-28.3L64.5,64.9L36.2,93.2z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.5,122.2l-29.1-29.1l14.7-14.7l29.1,29.1L150.5,122.2z M122.2,93.2l28.3,28.3l13.9-13.9l-28.3-28.3 L122.2,93.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.5,107.9L92.8,93.2l29.1-29.1l14.7,14.7L107.5,107.9z M93.6,93.2l13.9,13.9l28.3-28.3l-13.9-13.9 L93.6,93.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "164.8,107.9 172,100.7 172,99.9 164.8,107.1 150.9,93.2 172,72.1 172,71.3 150.1,93.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.8,150.9l-29-29.1l14.7-14.7l29.1,29.1L35.8,150.9z M7.6,121.8l28.3,28.3l13.9-13.9l-28.3-28.3L7.6,121.8z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.2,92.8 0,99.9 0,100.7 7.2,93.6 21.1,107.5 0,128.6 0,129.4 21.9,107.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.2,150.9l-29.1-29.1l14.7-14.7l29.1,29.1L93.2,150.9z M64.9,121.8l28.3,28.3l13.9-13.9l-28.3-28.3 L64.9,121.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.2,136.6l-14.7-14.7l29.1-29.1l14.7,14.7L50.2,136.6z M36.2,121.8l13.9,13.9l28.3-28.3L64.5,93.6 L36.2,121.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.5,150.9l-29.1-29.1l14.7-14.7l29.1,29.1L150.5,150.9z M122.2,121.8l28.3,28.3l13.9-13.9l-28.3-28.3 L122.2,121.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.5,136.6l-14.7-14.7l29.1-29.1l14.7,14.7L107.5,136.6z M93.6,121.8l13.9,13.9l28.3-28.3l-13.9-13.9 L93.6,121.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "164.8,136.6 172,129.4 172,128.6 164.8,135.8 150.9,121.8 172,100.7 172,99.9 150.1,121.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "21.5,135.8 6.8,150.5 28.3,172 29.1,172 7.6,150.5 21.5,136.6 49.8,164.8 42.6,172 43.4,172  50.6,164.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.2,121.4 0,128.6 0,129.4 7.2,122.2 21.1,136.2 0,157.3 0,158.1 21.9,136.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "78.8,135.8 64.1,150.5 85.6,172 86.4,172 64.9,150.5 78.8,136.6 107.1,164.8 99.9,172 100.7,172  107.9,164.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.2,165.2l-14.7-14.7l29.1-29.1l14.7,14.7L50.2,165.2z M36.2,150.5l13.9,13.9l28.3-28.3l-13.9-13.9 L36.2,150.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "136.2,135.8 121.4,150.5 142.9,172 143.7,172 122.2,150.5 136.2,136.6 164.4,164.8 157.3,172  158.1,172 165.2,164.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.5,165.2l-14.7-14.7l29.1-29.1l14.7,14.7L107.5,165.2z M93.6,150.5l13.9,13.9l28.3-28.3l-13.9-13.9 L93.6,150.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "164.8,165.2 172,158.1 172,157.3 164.8,164.4 150.9,150.5 172,129.4 172,128.6 150.1,150.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.9,172 14.7,172 21.5,165.2 28.3,172 29.1,172 21.5,164.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.2,150.1 0,157.3 0,158.1 7.2,150.9 21.1,164.8 13.9,172 14.7,172 21.9,164.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "71.3,172 72.1,172 78.8,165.2 85.6,172 86.4,172 78.8,164.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "64.5,150.1 42.6,172 43.4,172 64.5,150.9 78.4,164.8 71.3,172 72.1,172 79.2,164.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "128.6,172 129.4,172 136.2,165.2 142.9,172 143.7,172 136.2,164.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "121.8,150.1 99.9,172 100.7,172 121.8,150.9 135.8,164.8 128.6,172 129.4,172 136.6,164.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "172,158.1 172,157.3 157.3,172 158.1,172  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/Stack.97360162547550df818b909c970f6595.svg";
export { ForwardRef as ReactComponent };